import React, {
    Component
} from 'react'
import { actionTypes } from '../constants';
import _ from 'lodash';
import {
    Map,
    Marker,
    Popup,
    TileLayer,
    LayersControl,
    Circle,
    CircleMarker
} from 'react-leaflet';

const exmarxIconBase = L.Icon.extend({
    // https://leafletjs.com/examples/custom-icons/
    options: {
        iconUrl: '/dist/assets/img/marker-green.svg',
    }
});
const exmarxIcon = new exmarxIconBase();


export default class Container extends Component {
    constructor() {
        super()
        this.state = {
            is_loaded: false,
            map_center: [37.8651, 119.5383]
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        // did we fetch a different report?
        if(prevProps.reports.is_loaded === false && this.props.reports.is_loaded === true && this.props.reports.detail){
            let latitude = _.get(this.props.reports.detail, 'latitude', 0.0);
            let longitude = _.get(this.props.reports.detail, 'longitude', 0.0);
            console.log(`setState lat lng`)
            this.setState({
                map_center: [latitude, longitude]
            })
        }

        // have we loaded map center from props -> state?
        if(this.state.is_loaded === false && this.props.reports.is_loaded === true){
            let latitude = _.get(this.props.reports.detail, 'latitude', 0.0);
            let longitude = _.get(this.props.reports.detail, 'longitude', 0.0);
            console.log(`setState lat lng`)
            this.setState({
                is_loaded: true,
                map_center: [latitude, longitude]
            })
        }
    }

    render() {
        console.log(this.state)
        return (
            <React.Fragment>
                <div className="detail-map">
                    <Map center={this.state.map_center} zoom={14}>
                        <Marker position={this.state.map_center} icon={exmarxIcon}>
                            <Popup>A pretty CSS3 popup.<br />Easily customizable.</Popup>
                        </Marker>
                        <TileLayer
                            url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                            attribution={`&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors &copy; <a href='https://carto.com/attributions'>CARTO</a>`}
                            maxZoom={19}
                        />
                    </Map>
                </div>
                <div className="card-content">
                </div>
            </React.Fragment>
        )
    }
}
